import SubscriptionsCoreOnlyBlock from './SubscriptionsCoreOnlyBlock';
import SubscriptionsCoreOnlyBlockContainer from './SubscriptionsCoreOnlyBlock.container';

export default SubscriptionsCoreOnlyBlockContainer(SubscriptionsCoreOnlyBlock);
